import React, { useEffect, useState } from 'react';
import { META_AD_TYPE } from '../SocialMediaConstant';

const FacebookFeedAd = ({
    image,
    message,
    buttonType,
    link
}) => {

    link = link?.trim();
    const [tagline, setTagline] = useState("Loading tagline...");
    const [publisher, setPublisher] = useState("Bright Media");

    useEffect(() => {
        if(!link) return;
        fetchTagline();
    }, [link]);

    const fetchTagline = async (url) => {
        const response = await fetch(`https://api.microlink.io/?url=${encodeURIComponent(link)}`);
        const { data } = await response.json();
        setPublisher(data.publisher || data.author || "Bright Media");
        setTagline(data.title || "Visit Website");
    };

    return (
        <div style={{
            width: '295px',
            border: '1px solid #ccc',
            borderRadius: '0.5rem',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            fontFamily: 'sans-serif',
            backgroundColor: 'white'
        }}>
            <div style={{
                display: 'flex', alignItems: 'center', padding: '0.75rem', borderBottom: '1px solid #eee', padding: "0.75rem"
            }}>
                <i className='fa fa-brand fa-facebook pr-2' />
                <span style={{ fontSize: '0.75rem', fontWeight: '600', margin: 0 }}>Facebook Feed</span>
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'start',
                padding: '0.75rem',
                borderBottom: '1px solid #eee'
            }}>
                <img
                    src="https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png"
                    alt="Logo"
                    style={{ width: '2.5rem', height: '1.5rem', marginRight: '0.5rem' }}
                />
                <div style={{ flex: 1 }}>
                    <h2 style={{ fontSize: '0.75rem', fontWeight: '600', margin: 0 }}>Bright Media Solution</h2>
                    <span style={{ fontSize: '0.625rem', color: '#888' }}>Sponsored <span style={{ position: 'relative', bottom: '7px' }}>.</span> <i className='fa fa-globe' /></span>
                </div>
                <span style={{ fontWeight: 'bold', fontSize: '1.2rem', fontWeight: "900", position: 'relative', bottom: '10px' }}>...</span>
                <i style={{ cursor: 'pointer', fontSize: '1rem', marginLeft: '0.5rem' }} className='fa fa-times' />
            </div>

            <p style={{ padding: '0.5rem 0.75rem', fontSize: '0.75rem', fontWeight: '600', margin: 0 }}>{message}</p>

            <img
                src={image}
                alt="Ad"
                style={{
                    width: '295px',
                    height: '170px'
                }}
                className="img-fluid object-fit-cover"
            />

            <div style={{ padding: '0.75rem', display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                <div style={{ lineHeight: '0.8rem' }}>
                    <p style={{ fontSize: '0.75rem', fontWeight: '400', margin: 0 }}>{publisher}</p>
                    <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'block',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            color: 'black',
                            textDecoration: 'none',
                            marginBottom: '0.5rem',
                        }}
                    >
                        {tagline}
                    </a>
                </div>
                <button
                    style={{
                        padding: '0.4rem 0.75rem',
                        fontSize: '0.75rem',
                        backgroundColor: '#e5e7eb',
                        borderRadius: '0.375rem',
                        fontWeight: '600',
                        border: 'none',
                        cursor: 'pointer',
                        textWrap: 'nowrap'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#d1d5db'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e5e7eb'}
                >
                    {META_AD_TYPE[buttonType] || 'Learn More'}
                </button>
            </div>
            {/* Like, Comment, Share Buttons */}
            <div style={{
                borderTop: '1px solid #eee',
                display: 'flex',
                justifyContent: 'space-around',
                padding: '0.5rem 0',
                fontSize: '0.75rem',
                color: '#4b5563',
                fontWeight: '600',
            }}>
                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <i className="fa fa-thumbs-o-up" /> Like
                </span>
                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <i className="fa fa-comment-o" /> Comment
                </span>
                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <i className="fa fa-share" /> Share
                </span>
            </div>
        </div >
    );
};

export default FacebookFeedAd;
